var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDroneBlackMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.7852,
    cy: 24.3818,
    r: 22,
    fill: "white",
    stroke: "current",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3685 23.8367C13.183 24.0126 13.0346 24.224 12.9323 24.4584C12.83 24.6927 12.7758 24.9452 12.773 25.2009L12.773 31.3638C12.7702 31.4643 12.7956 31.5635 12.8461 31.6504C12.8967 31.7373 12.9705 31.8083 13.0592 31.8555C13.0926 31.8675 13.1283 31.8717 13.1635 31.8677C13.1987 31.8637 13.2325 31.8516 13.2623 31.8324L24.7734 24.0676L19.4299 20.3998C19.3768 20.2813 19.3395 20.1564 19.3191 20.0282C19.4072 19.8636 19.5124 19.7089 19.633 19.5665L13.3685 23.8321",
    fill: "current",
    fillOpacity: 0.38
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1776 23.8164C36.3633 23.9927 36.5116 24.2045 36.6139 24.4392C36.7162 24.6739 36.7704 24.9268 36.7732 25.1828L36.7732 31.3458C36.7764 31.446 36.7515 31.5452 36.7014 31.6321C36.6512 31.719 36.5777 31.7901 36.4892 31.8374C36.4559 31.8494 36.4202 31.8536 36.385 31.8496C36.3498 31.8456 36.3159 31.8335 36.2861 31.8143L24.7589 24.068L30.1163 20.3748C30.1703 20.2565 30.2083 20.1315 30.2294 20.0032C30.139 19.8496 30.033 19.7057 29.9131 19.5739L36.1776 23.8164Z",
    fill: "current",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7907 16.3696C24.5081 16.37 24.2313 16.45 23.992 16.6004L19.5833 19.6011C18.8378 20.1066 19.5833 20.6098 19.5833 20.6098L24.7607 24.0859L29.9265 20.6098C29.9265 20.6098 30.672 20.1066 29.9265 19.6011L25.5178 16.6004C25.2775 16.4503 25.0001 16.3703 24.7168 16.3696L24.7884 16.3696",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroneBlackMap);
export default __webpack_public_path__ + "static/media/DroneBlackMap.0272430b4a2f446a4900979d84656d4e.svg";
export { ForwardRef as ReactComponent };